import { Button, Modal } from '@heroui/react'
import { useTranslation } from 'react-i18next'

interface ConfirmCloneDialogProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onConfirm: () => void;
  title: string;
  description: string;
  isLoading?: boolean;
}

export function ConfirmCloneDialog({
  isOpen,
  onOpenChange,
  onConfirm,
  title,
  description,
  isLoading
}: ConfirmCloneDialogProps) {
  const { t } = useTranslation()

  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
      <Modal.Backdrop variant="blur" className="bg-zinc-950/40" isDismissable>
        <Modal.Container placement="center">
          <Modal.Dialog>
            <Modal.CloseTrigger />
            <Modal.Header>
              <Modal.Heading className="font-bold">
                {title}
              </Modal.Heading>
            </Modal.Header>
            <Modal.Body className="mt-2">
              <p className="text-sm text-zinc-500 dark:text-zinc-400">
                {description}
              </p>
            </Modal.Body>
            <Modal.Footer className="flex gap-3 justify-end mt-6">
              <Button
                variant="ghost"
                onClick={() => onOpenChange(false)}
              >
                {t('common.cancel')}
              </Button>
              <Button
                variant="primary"
                onClick={onConfirm}
                isDisabled={isLoading}
              >
                {isLoading ? (
                  <div className="flex items-center gap-2">
                    <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {t('common.clone')}
                  </div>
                ) : t('common.clone')}
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </Modal.Container>
      </Modal.Backdrop>
    </Modal>
  )
}
